import {useEffect, useState} from 'react'

import styles from './ProjectForm.module.css'

import Input from '../form/Input'
import Select from '../form/Select'
import SubmitButton from '../form/SubmitButton'
import { fetchCategories } from '../../services/api'

function ProjectForm({handleSubmit, btnText, projectData}) {

    const [project, setProject] = useState(projectData || {})
    const [categories, setCategories] = useState([])

    useEffect(() => {
        async function loadCategories() {
            try {
                const data = await fetchCategories();
                setCategories(data)
            } catch (err) {
                console.log(err)
            }
        }
        loadCategories();
    }, [])

    const submit = (e) => {
        e.preventDefault()
        handleSubmit(project)
    }

    function handleChange(e) {
        setProject({ ...project, [e.target.name]: e.target.value })
    }

    function handleCategory(e) {
        setProject({
        ...project,
        category: {
            id: e.target.value,
            name: e.target.options[e.target.selectedIndex].text,
        },
        })
    }

    return (
        <form onSubmit={submit} className={styles.form}>
          <Input
            type="text"
            text="Nome do projeto"
            name="name"
            placeholder="Insira o nome do projeto"
            handleOnChange={handleChange}
            value={project.name}
          />
          <Input
            type="number"
            text="Orçamento do projeto"
            name="budget"
            placeholder="Insira o orçamento total"
            handleOnChange={handleChange}
            value={project.budget}
          />
          <Select
            name="category_id"
            text="Selecione a categoria"
            options={categories}
            handleOnChange={handleCategory}
            value={project.category ? project.category.id : ''}
          />
          <SubmitButton text={btnText} />
        </form>
      )
}

export default ProjectForm